import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { formatError } from "@/lib/api";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success(`Welcome back, ${u.name || u.email}`);
      nav(u.role === "admin" ? "/admin" : "/");
    } catch (err) {
      toast.error(formatError(err.response?.data?.detail) || "Login failed");
    } finally { setLoading(false); }
  };

  const google = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirect = window.location.origin + "/auth/callback";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirect)}`;
  };

  return (
    <div className="mx-auto max-w-md px-6 py-24">
      <div className="overline text-accent mb-3">Sign in</div>
      <h1 className="font-editorial text-4xl text-primary tracking-tight">Welcome back.</h1>
      <p className="text-muted-foreground mt-2 text-sm">Access your dashboard, drafts, and documents.</p>

      <form onSubmit={submit} className="mt-10 space-y-5">
        <div><Label>Email</Label><Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-2 rounded-none" data-testid="login-email" /></div>
        <div><Label>Password</Label><Input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="mt-2 rounded-none" data-testid="login-password" /></div>
        <Button type="submit" disabled={loading} className="w-full rounded-full h-11" data-testid="login-submit">
          {loading ? "Signing in…" : "Sign in"}
        </Button>
        <div className="text-right">
          <Link to="/forgot-password" className="text-xs text-primary/70 hover:text-primary hover:underline underline-offset-4" data-testid="login-forgot-link">
            Forgot password?
          </Link>
        </div>
      </form>

      <div className="my-8 flex items-center gap-3 text-xs font-mono text-muted-foreground">
        <div className="flex-1 h-px bg-border" /> OR <div className="flex-1 h-px bg-border" />
      </div>
      <Button variant="outline" onClick={google} className="w-full rounded-full h-11" data-testid="login-google">
        Continue with Google
      </Button>

      <p className="text-sm text-muted-foreground mt-8 text-center">
        No account? <Link to="/register" className="text-primary link-underline" data-testid="login-register-link">Create one</Link>
      </p>
    </div>
  );
}
